import noop from 'utils/noop';
import { StyledSemanticDropdownItem, StyledSemanticCheckbox } from './MultiSelect.styled';

// type Props = {
//   /* Whether or not the item is indeterminate. */
//   indeterminate: boolean,
//   /* Callback when item is clicked. */
//   onClick: () => void,
//   /* Text to display for the item. */
//   text: string,
//   /* Whether or not the item is selected. */
//   selected: boolean,
//   /* Optional subtext to display below the text */
//   subtext: ?string,
//   /* The value of the item. */
//   value: ?string,
// };

const Item = ({ indeterminate, text, onClick = noop, selected = false, value, subtext }) => {
  const handleClick = () => {
    onClick({ text, selected, value });
  };

  return (
    <StyledSemanticDropdownItem data-test="core-multiselect-dropdown-item" onClick={handleClick}>
      <StyledSemanticCheckbox checked={selected} indeterminate={indeterminate} />
      <div>
        {text || value} {subtext && <div className="cssSubText">{subtext}</div>}
      </div>
    </StyledSemanticDropdownItem>
  );
};

export default Item;
